<template>
  <v-row></v-row>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import {cart3Request} from '../../../api/models';
import * as Storage from '@/core/storage.js';

export default {
  name: 'Cart3',

  mounted() {
    this.initCart3Data();
  },

  computed: {
    ...mapState({cartStore: state => state.cart}),
  },

  watch: {
    '$store.state.cart.cart3Data'() {
      if (this.cartStore.cart3Data) {
        this.prepareAndRedirectToCreateOrder();
      }
    },
  },

  methods: {
    ...mapActions('cart', ['getCartStep3']),
    ...mapActions('orders', ['createOrder']),
    ...mapActions('alerts', ['error']),

    // --- FIX: parser seguro para no tronar con "[object Object]"
    safeParse(item) {
      try {
        if (typeof item === 'string') return JSON.parse(item);
        return item;
      } catch (e) {
        return null;
      }
    },

    initCart3Data() {
      let rawCart3 = Storage.getItem('cart3');
      let cart3Parsed = this.safeParse(rawCart3);

      let request = cart3Request();
      request.cart3 = cart3Parsed;

      // Si no se pudo parsear correctamente
      if (!request.cart3) {
        this.error('Hubo un error al continuar con el proceso del portafolio, vuelve a iniciar.');
        this.$router.push({name: 'portfolio', params: {step: 1}});
        return;
      }

      // Vuex call
      this.getCartStep3(request);
    },

    prepareAndRedirectToCreateOrder() {
      const cart = {};
      const dataInvoice = {};

      const cart3 = this.cartStore.cart3Data;

      if (!cart3 || !Array.isArray(cart3.facturas)) {
        this.error('Información incompleta para generar la orden.');
        return;
      }

      cart3.facturas.forEach((invoice) => {
        const tramites = invoice.tramites || [];

        tramites.forEach((procedure, index2) => {
          const tramite = procedure?.tramite;

          if (!tramite) return;

          const fiscalId = invoice.dato_fiscal?.id ?? '0';

          if (!cart[fiscalId]) cart[fiscalId] = {};

          cart[fiscalId]['' + index2] = tramite.id;

          // Procesar datos de facturación
          if (tramite.facturable == 1) {
            if (procedure.datos_factura) {
              const dataFiscalId = invoice.dato_fiscal ? tramite.id : '0';
              dataInvoice['' + dataFiscalId] = procedure.datos_factura.id;
            }
          }
        });
      });

      Storage.setItem('finalCart', JSON.stringify(cart));
      Storage.setItem('finalCartInvoice', JSON.stringify(dataInvoice));

      this.$router.push({
        name: 'orders',
        params: {action: 'create'},
      });
    },
  },
};
</script>

<style></style>